import React, { useMemo, useState } from 'react';

import { MESSAGE_MODALS } from '../../context/custom/MessageModalContext';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../config/apis';
import { PERMISSIONS } from '../../consts/permissions';
import { ServerRequest } from '../../utils/apiweb';
import { TableCustom, SectionHeading, InputLista, Select } from '../../components/common';
import TipoElementoModal from '../../components/controls/TipoElementoModal';
import { useLista, useManagedContext } from '../../components/hooks';



function TipoElementoView() {
    const { setIsLoading, showMessageModal } = useManagedContext()

    //hooks
    const [state, setState] = useState({
        showForm: false,
        modeFormEdit: false,
        rowId: 0,
        list: []
    });

    const [idTipoTributoState, setIdTipoTributoState] = useState(0)
    const [idClaseElementoState, setIdClaseElementoState] = useState(0)
    const [listClaseElementoState, setListClaseElementoState] = useState([])
    
    const claseElementoRow = useMemo(() => {
        if (parseInt(idClaseElementoState) > 0)
            return listClaseElementoState.find(f => f.id === idClaseElementoState);
        else {
            return null;
        }
    }, [idClaseElementoState]);

    const [, getRowLista ] = useLista({
        listas: ['UnidadMedida'],
        memo: {
          key: 'UnidadMedida',
          timeout: 0
        }
    });

    const getDescClaseElemento = (id) => {
        const row = listClaseElementoState.find(value => value.id === id);
        return (row) ? row.nombre : '';
    }

    const getDescUnidadMedida = (id) => {
        const row = getRowLista('UnidadMedida', id);
        return (row) ? row.nombre : '';
    }

    //definiciones
    const tableColumns = [
        { Header: 'Clase elemento', Cell: (props) => {
            const row = props.row.original;
            const claseElemento = getDescClaseElemento(row.idClaseElemento);
            return claseElemento;
          }, id: 'claseElemento', accessor: 'idClaseElemento', width: '30%' },
        { Header: 'Código', accessor: 'codigo', width: '10%' },
        { Header: 'Orden', accessor: 'orden', width: '5%' },
        { Header: 'Nombre', accessor: 'nombre', width: '30%' },
        { Header: 'Unidad de medida', accessor: 'idUnidadMedida', id:'unidadMedida', width: '15%' , Cell: (props) => {
            const row = props.row.original;
            const unidadMedida = getDescUnidadMedida(row.idUnidadMedida);
            return unidadMedida;
        }}
    ];


    //handles
    const avmr = {
        onAdd: () => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: 0}))
        },
        onView: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: false, rowId: parseInt(id)}))
        },
        onModify: ({ id }) => {
            setState(prevState => ({...prevState, showForm: true, modeFormEdit: true, rowId: parseInt(id)}))
        },
        onRemove: ({ id }) => {
            const item = state.list.find(x => x.id === id)
            showMessageModal({
                ...MESSAGE_MODALS.BORRAR,
                message: `¿Está seguro de borrar el elemento ${item.nombre}?`,
                onConfirm: () => DeleteTipoElemento(id)
            })
        },
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setIsLoading(false)
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setIsLoading(false)
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setIsLoading(false)
    }

    //funciones
    function SearchClasesElementos(idTipoTributo){
        setIdTipoTributoState(idTipoTributo);
        setIdClaseElementoState(0);               
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [], }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setIsLoading(false);
                data = data.map(value => {
                    return {
                        id: value.id,
                        nombre: value.nombre
                    }
                });

                setListClaseElementoState(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        const paramsUrl = `/tipo-tributo/${idTipoTributo}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CLASE_ELEMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    }

    function SearchTiposElementos(idClaseElemento){
        setIdClaseElementoState(idClaseElemento);
        setIsLoading(true)
        setState(prev => ({ ...prev, list: [], }))

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setIsLoading(false);
                setState(prev => ({ ...prev, list: data }))
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setIsLoading(false)
            });
        };

        const paramsUrl = `/clase-elemento/${idClaseElemento}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_ELEMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    }

    function DeleteTipoElemento(id) {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.TIPO_ELEMENTO,
            `/${id}`,
            null,
            () => {
                SearchTiposElementos(idClaseElementoState)
                setIsLoading(false)
            },
            () => {
                callbackNoSuccess()
                setIsLoading(false)
            },
            () => {
                callbackError()
                setIsLoading(false)
            },
        )
    }

    return (
    <>
        {claseElementoRow && state.showForm && 
            <TipoElementoModal
                id={state.rowId}
                claseElemento={claseElementoRow}
                disabled={!state.modeFormEdit}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false};
                    });
                }}
                onConfirm={(id) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowId: 0};
                    });

                    SearchTiposElementos(idClaseElementoState);
                }}
            />
        }

        <SectionHeading titles={[{ title: 'Configuración' }, { title: 'Administración de tipos'}]} />

        <section className='section-accordion'>
            <div className="m-top-20">
                <div className='row form-basic'>
                    <div className="col-3">
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={idTipoTributoState}
                            title="Tipo tributo"
                            lista="TipoTributo"
                            onChange={({ target })  =>{
                                let idTipoTributo = 0;
                                if (target.row) {
                                    idTipoTributo = parseInt(target.value);
                                }
                                SearchClasesElementos(idTipoTributo);
                            }}
                        />
                    </div>
                    <div className="mb-3 col-12 col-lg-4">
                            <label htmlFor="claseElemento" className="form-label">Clase elemento</label>
                            <Select
                                name="claseElemento"
                                className="form-control"
                                value={ idClaseElementoState }
                                options={[{ value: 0, label: 'Sin selección' }, ...listClaseElementoState.map(item => ({ value: item.id, label: item.nombre }))]}
                                onChange={({ target }) => {
                                    SearchTiposElementos(target.value);
                                }}
                                disabled={listClaseElementoState.length === 0}
                            />
                    </div>
                </div>
            </div>
            {idClaseElementoState !== 0 && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    columns={tableColumns}
                    data={state.list}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    messageEmpty="No se encontraron resultados"
                />
            )}

        </section>
        
    </>
    )
}

export default TipoElementoView;
